const chat = {  

   //Chat
chat: {
  // --- Löschen / Bestätigungen ---
  deleteMessage: {
    everyone: "Diese Nachricht für alle löschen?",
    me: "Diese Nachricht nur für dich löschen?",
  },

  deletedUser: "Gelöschter Benutzer",

  deleteConversation: {
    deletedUser:
      "Diese Unterhaltung dauerhaft löschen? Alle Nachrichten und Medien werden entfernt und können nicht wiederhergestellt werden.",

    normal:
      "Diese Unterhaltung mit {{name}} löschen? Der andere Teilnehmer behält weiterhin seine Kopie (Nachrichten, Medien und Profilname).",
  },

  // --- Ende-zu-Ende-Verschlüsselung / Fehler ---
  e2eeInitializing: "Der sichere Chat wird auf diesem Gerät noch initialisiert.",

  // {{msg}} = API-Fehlermeldung vom Backend
  sendFailed: "Senden fehlgeschlagen: {{msg}}",

  // --- Seitenleiste / Vorschau ---
  preview: {
    message: "Nachricht",
    photo: "Foto",
    video: "Video",
    audio: "Audio",
    media: "Medien",
  },

  // --- Kopfbereich / Profil ---
  openVisitorProfile: "Besucherprofil öffnen",
  fallbackUser: "Benutzer",
  unknownUser: "Unbekannter Benutzer",

  // --- Eingabefeld / Schaltflächen / Hinweise ---
  addMedia: "Medien hinzufügen",
  pickChatFirst: "Wähle zuerst einen Chat aus",
  replying: "Antwort an",
  placeholder: "Nachricht eingeben…",
  emoji: "Emoji",
  send: "Senden",

  // --- Leere Zustände / Hinweise ---
  selectUserHint: "Wähle links einen Benutzer aus, um einen Chat zu starten.",

  upload: {
    headerTitle: "Medien an {{name}} senden",
    genericUser: "Benutzer",

    back: "Zurück",

    addButton: "Fotos/Videos hinzufügen",
    addButtonTitleReady: "Fotos & Videos auswählen",
    addButtonTitleInit: "Sicherer Chat wird initialisiert…",

    dropTitle: "Dateien hier anklicken oder ablegen",
    dropHelp: "Klicke hier, um Bilder oder Videos auszuwählen, oder ziehe sie hierher.",

    ttlTitle: "Wie lange diese Medien nach dem Ansehen verfügbar bleiben sollen",

    ttl: {
      choose: "Ablaufzeit auswählen…",
      afterView: "Sofort nach dem Ansehen",
      min1: "1 Minute",
      min5: "5 Minuten",
      hour1: "1 Stunde",
      hours24: "24 Stunden",
      days3: "3 Tage",
      days30: "30 Tage",
    },

    sendCta: "{{count}} senden & weiter →",

    kindImage: "Bild",
    kindVideo: "Video",

    remove: "Entfernen",
  },

  message: {
    media: {
      expired: "Abgelaufen",
      expiredTitle: "Medien abgelaufen",
      show: "Medien anzeigen",
      showWithCount: "Medien anzeigen ({{count}})",
    },

    menu: {
      optionsTitle: "Nachrichtenoptionen",
      copy: "Kopieren",
      reply: "Antworten",
      delete: "Nachricht löschen",
    },

    quoted: {
      unknownUser: "Benutzer",
    },
  },

  date: {
    today: "Heute",
    yesterday: "Gestern",
  },
},

//ChatMediaPresentation
chatMedia: {
  videoTitle: "Video",
  noMedia: "Keine Medien zum Anzeigen.",
},

} as const;
  
  export default chat;
  